export function calcCountInLength(mapPoints, mapL, minLength, maxLength, extensionFront, extensionBack) {
    const mapStart = mapL[0][0];
    const mapEnd = mapL[1][0];
    const coverStart = mapStart - extensionBack;
    const coverEnd = mapEnd + extensionFront;
    const fullLength = coverEnd - coverStart;
    // ✅ 1. ПРОБУЕМ ОДНУ ДОСКУ НА ВСЁ
    if (fullLength >= minLength && fullLength <= maxLength) {
        return {
            ok: true,
            segments: [{
                    from: [coverStart, 0],
                    to: [coverEnd, 0],
                    length: fullLength,
                }]
        };
    }
    // Количество досок
    let countBoard = Math.ceil(fullLength / maxLength);
    // Размер последней доски
    let lastBoardSize = fullLength - maxLength * (countBoard - 1);
    if (lastBoardSize < minLength) {
        lastBoardSize = minLength;
    }
    let from = coverStart;
    let prev = 0;
    let I = 0;
    // 2. Точки разрыва ТОЛЬКО внутри mapL
    const cutPoints = mapPoints
        .map(p => p[0])
        .filter(x => x > mapStart && x < mapEnd)
        .sort((a, b) => a - b);
    const segments = [];
    for (let i = 0; i < cutPoints.length; i++) {
        if (cutPoints[i] < lastBoardSize) {
            continue;
        }
        segments.push({
            from: [from, 0],
            to: [cutPoints[i], 0],
            length: cutPoints[i] - from,
        });
        from = cutPoints[i];
        I = i;
        prev = cutPoints[i];
        countBoard--;
        break;
    }
    for (let i = I; i < cutPoints.length; i++) {
        const len = cutPoints[i] - from;
        if (countBoard === 1) {
            const remaining = coverEnd - from;
            if (remaining > maxLength) {
                // ищем минимально возможную доску от from
                let splitPoint = 0;
                for (let j = i; j < cutPoints.length; j++) {
                    const testLen = cutPoints[j] - from;
                    if (testLen >= minLength) {
                        splitPoint = cutPoints[j];
                        break;
                    }
                }
                // первая из двух
                segments.push({
                    from: [from, 0],
                    to: [splitPoint, 0],
                    length: splitPoint - from,
                });
                // вторая — остаток
                segments.push({
                    from: [splitPoint, 0],
                    to: [coverEnd, 0],
                    length: coverEnd - splitPoint,
                });
                countBoard = 0;
                break;
            }
        }
        if (len <= maxLength) {
            // пока в пределах maxLength — запоминаем как кандидат
            prev = cutPoints[i];
        }
        else {
            // превысили — фиксируем предыдущую максимально возможную
            segments.push({
                from: [from, 0],
                to: [prev, 0],
                length: prev - from,
            });
            countBoard--;
            from = prev;
            prev = cutPoints[i];
            // откатываемся на шаг назад,
            // чтобы проверить эту же точку уже от нового from
            i--;
        }
        // если это последняя точка — фиксируем финальный сегмент
        if (i === cutPoints.length - 1) {
            segments.push({
                from: [from, 0],
                to: [coverEnd, 0],
                length: coverEnd - from,
            });
        }
    }
    return { ok: true, segments };
}
export function calcSegmentsWithPoints(segments, line, line2) {
    const result = [];
    for (let s = 0; s < segments.length; s++) {
        const seg = segments[s];
        const from = seg.from;
        const to = seg.to;
        const newSeg = {
            from,
            to,
            length: seg.length,
            points: [],
        };
        for (let i = 0; i < line.length; i++) {
            const x1 = line[i][0];
            const x2 = line2[i][0];
            if (x1 < from[0] || x1 > to[0])
                continue;
            const localX1 = x1 - from[0];
            const localX2 = x2 - from[0];
            let kind = null;
            if ((x1 === from[0] && s !== 0)) {
                kind = 'joinStart';
            }
            else if ((x1 === to[0] && s !== segments.length - 1)) {
                kind = 'joinEnd';
            }
            else if ((x1 > from[0] && x1 < to[0])) {
                kind = 'complexCut';
            }
            if (!kind)
                continue;
            newSeg.points.push({
                kind,
                point1: [localX1, line[i][1]],
                point2: [localX2, line2[i][1]],
            });
        }
        result.push(newSeg);
    }
    return result;
}
